import React from 'react';

interface LogoProps {
  className?: string;
  // Appearance prop is no longer needed, color will be inherited via text color
}

// Removed COLOR constants

const Logo: React.FC<LogoProps> = ({ 
  className = 'h-8 w-auto', 
}) => {
  // Removed appearance logic

  return (
    // Container div controls size, color is set by parent via text-* class
    <div className={`flex items-center ${className}`}> 
      <svg 
        className="h-full w-full" 
        id="Layer_2" 
        data-name="Layer 2" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlnsXlink="http://www.w3.org/1999/xlink" 
        viewBox="0 0 510.67 163.6"
        preserveAspectRatio="xMidYMid meet"
        // Set fill to currentColor to inherit from parent's text color
        fill="currentColor" 
      >
        <defs>
          <clipPath id="clippath">
            {/* Use currentColor for clip path elements if they should inherit color */}
            <polygon points="50.92 67.77 13.57 67.77 12.37 .5 50.92 .4 50.92 67.77" fill="currentColor"/> 
          </clipPath>
        </defs>
        <g id="Layer_1-2" data-name="Layer 1">
          {/* Removed explicit fill attributes, relies on SVG's fill="currentColor" */}
          <path d="M8.14,149.25c.01-1.45,1.23-.56,1.59-.17,7.36,8.04,15.53,4.75,23.11,1.72,23.21-9.27,46.7-15.63,70.4-19.95,13.71-2.5,27.52-3.48,41.28-5.04,23.19-2.61,46.36-6.06,69.57-7.44,25.49-1.52,51.01-1.45,76.52-1.41,15,.02,29.99.76,44.95,2.07,34.44,3.03,69.02,4.45,102.93,15.33,19.24,6.18,38.3,13.65,57.4,20.83,2.04.77,3.86,3.02,5.75,4.8.36.34.52.97.39,1.56l-.24,1.08c-.15.68-.64,1.07-1.12.91-3.74-1.24-7.55-2.18-11.17-3.98-21.66-10.73-43.97-16.54-66.38-21.65-39.52-9.02-79.35-11.79-119.24-12.62-28.36-.59-56.74-1.22-85.09.03-27.61,1.22-55.22,3.91-82.75,7.64-25.7,3.48-51.33,8.73-76.92,14.11-10.65,2.24-21.05,7.45-31.68,10.08-5.04,1.25-10.41,3.04-15.52-1.01-1.6-1.09-2.02-3.23-3.16-5.37-.3-.57-.62-1.55-.62-1.55h0Z"/>
          {/* Set stroke to currentColor too */}
          <line stroke="currentColor" fill="none" strokeMiterlimit="10" strokeWidth=".5px" x1="1.52" y1="132" x2="1.52" y2="100.73"/> 
          <path d="M7.95,136.19l-1,7.57c-.12.65-.03,1.35.3,1.86.21.33.52.57.94.47.66-.15.84-1.15.88-1.88.02-.44-.03-.88-.13-1.3l-.99-6.72Z"/>
          <path d="M3.19,13.21h.46c2.67,0,6.31.04,8.99,0,.24,6.89.58,26.42,1.08,40.61.37,10.61.75,21.22,1.13,31.84.24,6.81.48,13.62.75,20.43.05,1.4.22,1.86-.46,3.42-3.02,6.11-6.46,26.86-6.46,26.86,0,0-.27-36.1-.7-37.65-.37-1.35-.63-.03-.63-.03-.26,1.06.43,37.68.43,37.68,0,0-2.93-18.83-7.44-27.27-.28-.71-.36-1.48-.33-2.44.22-6.48.42-12.95.63-19.43.31-9.34.61-18.68.92-28.02.33-10.17.67-20.33,1-30.5.19-5.76.37-8.32.56-14.08.01-.44.04-.88.06-1.41Z"/>
          <g clipPath="url(#clippath)">
            <path d="M14.75,66.39l12.49.05c10.9,0,19.71-9.26,19.71-20.61v-22.25c0-11.2-8.81-20.46-19.71-20.46l-13.01.02c-.26,2.65-.53,4.76-.79,9.26.2,20.83.72,29.08,1.06,44.19,0,2.65.26,5.82.26,9.79ZM14.49,56.6l-1.32-44.19,14.07.13c5.67,0,10.3,4.93,10.3,11.05v22.25c0,6.27-4.63,11.05-10.3,11.05l-9.84-.28"/>
          </g>
          <path d="M3.16,12.42c-.05-.27-.99-9.27-.99-9.27h11.39l-.91,9.26H3.16Z"/>
          <path d="M12.9,12.41h1.06c.06,0,.27.04.27.1l2.64,43.82-2.38.26-1.59-44.19Z"/> 
          {/* Group for text elements - relies on SVG fill="currentColor" */}
          <g>
            {/* PRO part */}
            <path d="M94.99,69.01v21.38h-10.26v-21.38c0-5.29-4.32-9.61-9.61-9.61h-8.64v31h-10.26V3.02h19.98c10.15,0,18.36,8.53,18.36,18.9v18.58c0,5.62-2.38,10.48-5.94,14.04,3.89,3.56,6.37,8.75,6.37,14.47ZM84.4,21.92c0-4.75-3.67-8.64-8.21-8.64h-9.72v35.86h9.72c4.54,0,8.21-3.89,8.21-8.64v-18.58Z"/>
            <path d="M147.47,22.89v47.63c0,10.8-8.96,19.87-19.66,19.87h-1.08c-10.8,0-19.66-9.07-19.66-19.87V22.89c0-10.91,8.86-19.87,19.76-19.87h.97c10.8,0,19.66,8.96,19.66,19.87ZM137.21,22.89c0-5.29-4.21-9.61-9.4-9.61h-1.08c-5.29,0-9.5,4.32-9.5,9.61v47.63c0,5.4,4.21,9.5,9.5,9.5h1.08c5.18,0,9.4-4.1,9.4-9.5V22.89Z"/>
            {/* CREATIVE part */} 
            <path d="M168.86,22.79v47.95c0,5.18,4.21,9.4,9.5,9.4h1.08c3.89,0,7.45-2.48,8.75-6.16l9.72,3.35c-2.81,7.78-10.37,13.07-18.47,13.07h-1.08c-10.8,0-19.66-8.96-19.66-19.66V22.79c0-10.91,8.86-19.76,19.66-19.76h1.08c5.18,0,10.04,1.94,13.72,5.72,2.59,2.38,4.21,5.29,5.18,8.53l-9.83,2.92c-.43-1.62-1.3-3.02-2.48-4.21-1.84-1.84-4.21-2.7-6.59-2.7h-1.08c-5.29,0-9.5,4.32-9.5,9.5Z"/>
            <path d="M250.29,69.01v21.38h-10.26v-21.38c0-5.29-4.32-9.61-9.61-9.61h-8.64v31h-10.26V3.02h19.98c10.15,0,18.36,8.53,18.36,18.9v18.58c0,5.62-2.38,10.48-5.94,14.04,3.89,3.56,6.37,8.75,6.37,14.47ZM239.71,21.92c0-4.75-3.67-8.64-8.21-8.64h-9.72v35.86h9.72c4.54,0,8.21-3.89,8.21-8.64v-18.58Z"/>
            <path d="M262.38,3.02h31.1v10.26h-20.95v31.97h12.53v10.26h-12.53v24.73h20.95v10.15h-31.1V3.02Z"/>
            <path d="M347.92,90.39h-10.48l-4.43-23.11h-12.74l-4.54,23.11h-10.37L322.22,3.02h8.75l16.96,87.37ZM331.07,57.13l-4.54-23.11-4.32,23.11h8.86Z"/>
            <path d="M348.57,3.02h36.07v10.26h-12.74v77.11h-10.26V13.28h-13.07V3.02Z"/>
            <path d="M397.92,3.02h10.15v87.37h-10.15V3.02Z"/>
            <path d="M441.98,59.29l10.69-56.27h10.48l-16.85,87.37h-8.75L420.6,3.02h10.37l11.02,56.27Z"/>
            <path d="M473.3,3.02h31.1v10.26h-20.95v31.97h12.53v10.26h-12.53v24.73h20.95v10.15h-31.1V3.02Z"/>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Logo;
